// @flow

import React, {Fragment} from 'react';

import StateButton from 'app/general/widgets/StateButton';
import {getUserStatusAlerts} from 'app/user/users-statuses';

import {UserSerializedType} from 'sweet-types';

interface Props {
  isSuperManager: boolean;
  user: UserSerializedType;
  actions: {[action: string]: null | (() => Promise<any>)};
  isSaml: boolean;
  refreshData?: () => unknown;
}

export const UserStatusesAlerts = ({
  isSuperManager,
  user,
  actions,
  isSaml,
  refreshData,
}: Props): JSX.Element => (
  <Fragment>
    {getUserStatusAlerts(user, isSaml).map(
      ({action, ActionButton, icon, color, alertDescription}) => (
        <div
          className={`mb-3 alert alert-${color} d-flex align-items-center justify-content-between`}
          key={color + icon}
        >
          <div className="flex-grow-0 mr-3">
            <i className={`fa-fw ${icon}`} />
          </div>
          <div className="flex-grow-1 d-flex align-items-center justify-content-between">
            {alertDescription}
            {isSuperManager && ActionButton != null ? (
              <ActionButton refreshData={refreshData} user={user} />
            ) : isSuperManager &&
              action.propName != null &&
              actions[action.propName] != null &&
              action.name != null ? (
              <StateButton
                className={`btn alert-link btn-sm ml-2`}
                onClick={actions[action.propName]!}
                busyText={action.name}
              >
                {action.name}
              </StateButton>
            ) : null}
          </div>
        </div>
      )
    )}
  </Fragment>
);
